import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(name, score, allAns) {
  const obj = {
    name: name,
    score: score,
  };
  let test = {};
  for (let i = 0; i < allAns.length; i++) {
    test = { [`ans${i + 1}`]: allAns[i].answer_id };
    Object.assign(obj, test);
  }
  return obj;
}

const TableStudentScore = ({
  selectedClass,
  selectedWeek,
  dataTable,
  selectedGender,
}) => {
  const renderRow = () => {
    const test1 = [];
    for (let i = 0; i < dataTable.length; i++) {
      const test3 = createData(
        dataTable[i].user,
        dataTable[i].data.score,
        dataTable[i].data.allAnswer
      );
      test1.push(test3);
    }
    if (selectedGender === 3) {
      return test1;
    } else if (selectedGender === 2) {
      return test1.filter((item) => item.name[0] === "g");
    } else {
      return test1.filter((item) => item.name[0] === "b");
    }
  };
  const renderIcon = (ans) => {
    return (
      <i class="material-icons-round" style={{ color: ans ? "green" : "red" }}>
        {ans ? "check" : "clear"}
      </i>
    );
  };
  const renderHeaderColumn = () => {
    if (dataTable.length > 0) {
      const test = dataTable.map((item) => item.data)[0].allAnswer;
      return test.map((item, idx) => (
        <TableCell align="right">ข้อที่{idx + 1}</TableCell>
      ));
    } else {
      return <TableCell align="right">ข้อที่0</TableCell>;
    }
  };
  if (dataTable.length === 0) {
    return (
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        ไม่มีข้อมูลนักเรียน
      </div>
    );
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">username</TableCell>
            <TableCell align="center">คะแนนที่ได้ในบทนี้</TableCell>
            {renderHeaderColumn()}
          </TableRow>
        </TableHead>
        <TableBody>
          {renderRow().map((item) => {
            const testObject = Object.entries(item);
            return (
              <TableRow
                key={item.name}
                // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {testObject.map((item2) => {
                  if (typeof item2[1] === "boolean") {
                    return (
                      <TableCell align="right">
                        {renderIcon(item2[1])}
                      </TableCell>
                    );
                  } else {
                    if (typeof item2[1] === "string") {
                      return <TableCell align="left">{item2[1]}</TableCell>;
                    } else {
                      return <TableCell align="center">{item2[1]}</TableCell>;
                    }
                  }
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableStudentScore;
